import { AxiosError } from 'axios';
import { getApiErrorMeta } from './getApiErrorMeta';

const ERROR_CODE_MESSAGE_MAP = {
  'AEG-COMMON-401-000': '로그인이 필요합니다.',
  'AEG-COMMON-403-000': '권한이 없습니다.',
  'AEG-COMMON-404-000': '요청한 정보를 찾을 수 없습니다.',
  'AEG-COMMON-429-000': '요청이 너무 많습니다. 잠시 후 다시 시도해주세요.',
  'AEG-COMMON-500-000': '일시적인 서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
  'AEG-TEAM-400-006': '팀장은 다른 멤버에게 리더를 위임한 뒤에 팀을 옮길 수 있습니다.',
} as const satisfies Record<string, string>;

/**
 * Extract a human-readable error message from an API error response.
 *
 * Priority:
 *  1. `data.errorCode` mapped message
 *  2. `data.errors[0]` - specific validation errors from backend
 *  3. `data.message`   - general error message (may be "Bad Request")
 *  4. `error.message`  - Axios default (e.g. "Request failed with status code 400")
 *  5. fallback string
 */
export function getApiErrorMessage(error: unknown, fallback?: string): string {
  if (error instanceof AxiosError) {
    const meta = getApiErrorMeta(error);
    const mappedMessage = meta?.errorCode
      ? ERROR_CODE_MESSAGE_MAP[meta.errorCode as keyof typeof ERROR_CODE_MESSAGE_MAP]
      : undefined;

    if (mappedMessage) {
      return mappedMessage;
    }

    if (meta?.errors?.length) {
      return meta.errors[0] as string;
    }

    if (meta?.message) {
      return meta.message;
    }

    return fallback ?? error.message;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return fallback ?? '알 수 없는 오류가 발생했습니다.';
}
